module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navTabs"
  }, [_c('div', {
    staticClass: "Content"
  }, [_c('ul', {
    staticClass: "clear",
    style: ([_vm.ulWidth])
  }, _vm._l((_vm.data && _vm.data.length > 0 ? _vm.data : null), function(item, index) {
    return _c('li', {
      ref: "navTabsLi",
      refInFor: true,
      staticClass: "navTabsLi",
      class: _vm.pathFn === item.url ? 'navTabsLiAc' : '',
      style: ([_vm.liWidth]),
      on: {
        "click": function($event) {
          return _vm.actionFn(item)
        }
      }
    }, [_c('span', {
      staticClass: "val"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-318ea36f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/navTbas/src/navTabs.vue
// module id = 520
// module chunks = 0